import { asApr } from "@silo/utils";
import { MerklRewardLegacy } from "@silo/types";
import {
  GetBorrowAprMetricsParams,
  getBorrowAprMetrics,
  getBorrowState,
  getBorrowStateColor,
  getDepositAprMetrics,
} from "./utils";
import { classNames } from "../../utils/class-names";
import { FireIcon } from "../../icons";
import { ReactNode } from "react";

export interface MarketCardDepositProps {
  depositApr: bigint;
  depositRewardsApr: bigint;
  isProtected: boolean;
  rewardsSymbol: string;
  merklRewards: MerklRewardLegacy[];
}

export function MarketCardDeposit(props: MarketCardDepositProps): JSX.Element {
  const { hasDepositRewardsApr, totalDepositApr } = getDepositAprMetrics(props);

  return (
    <span
      className={classNames(
        "font-mono text-sm font-medium text-white",
        hasDepositRewardsApr ? "text-amber-300" : ""
      )}
    >
      {asApr(totalDepositApr)}
    </span>
  );
}

export interface MarketCardBorrowProps extends GetBorrowAprMetricsParams {
  isBorrowAprFixed: boolean;
}

export function MarketCardBorrow({
  borrowApr,
  borrowRewardsApr,
  rewardsSymbol,
  merklRewards,
  isBorrowAprFixed,
}: MarketCardBorrowProps): JSX.Element {
  const { hasBorrowRewardsApr, totalBorrowApr } = getBorrowAprMetrics({
    borrowApr,
    borrowRewardsApr,
    merklRewards,
    rewardsSymbol,
  });
  const borrowState = getBorrowState(hasBorrowRewardsApr, totalBorrowApr);

  return (
    <div className="flex items-center justify-end gap-1 font-mono text-sm font-medium text-white">
      <span
        className={classNames(
          "flex flex-col items-end",
          isBorrowAprFixed ? "text-amber-300" : "",
          getBorrowStateColor(borrowState)
        )}
      >
        <span>{asApr(totalBorrowApr)}</span>

        {isBorrowAprFixed && <span className="font-sans">Fixed</span>}
      </span>

      {borrowState === "netYield" && (
        <FireIcon className="w-4 h-4 text-green-400" />
      )}
    </div>
  );
}

interface MarketCardDetailsProps {
  className?: string;
  assets: MarketCardDetailsAsset[];
}

interface MarketCardDetailsAsset {
  symbol: string;
  merklRewards: MerklRewardLegacy[];
  points: ReactNode | null;
}

export function MarketCardDetails({
  className,
  assets,
}: MarketCardDetailsProps): JSX.Element {
  return (
    <div className={classNames("flex flex-col gap-5", className)}>
      {assets.map((asset) => {
        return <></>;
      })}
    </div>
  );
}
